(function () {
	function initAccordion() {
		// Find each accordion block instance by its data attributes
		const wrappers = document.querySelectorAll('[data-accordion-mode]');

		if (!wrappers.length) return;

		wrappers.forEach(function (wrapper) {
			const accordion = wrapper.querySelector('.accordion');
			if (!accordion) return;

			const mode = wrapper.dataset.accordionMode || 'single-open'; // 'single-open' | 'multi-open'
			const openFirst = wrapper.dataset.openFirstItem || 'closed'; // 'open' | 'closed'

			const items = accordion.querySelectorAll('.accordion-item');
			const headers = accordion.querySelectorAll('.accordion-header');

			if (!headers.length) return;

			// Open first item on load if configured
			if (openFirst === 'open' && items.length) {
				items[0].classList.add('is-open');
			}

			headers.forEach(function (header) {
				header.addEventListener('click', function () {
					const item = header.closest('.accordion-item');
					if (!item) return;

					const wasOpen = item.classList.contains('is-open');

					if (mode === 'single-open') {
						// Close all items first
						items.forEach(function (accordionItem) {
							accordionItem.classList.remove('is-open');
						});

						// Only open the clicked one if it wasn't already open
						if (!wasOpen) {
							item.classList.add('is-open');
						}
					} else {
						// Multi-open: simple toggle
						item.classList.toggle('is-open');
					}
				});
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAccordion);
	} else {
		initAccordion();
	}
})();
